import { render, staticRenderFns } from "./PersonalLike.vue?vue&type=template&id=00afac7a&scoped=true"
import script from "./PersonalLike.vue?vue&type=script&lang=js"
export * from "./PersonalLike.vue?vue&type=script&lang=js"
import style0 from "./PersonalLike.vue?vue&type=style&index=0&id=00afac7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00afac7a",
  null
  
)

export default component.exports